import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/gem-logo.webm")